import { createApp } from 'vue'

import { RiseUI } from '@experiments-labs/rise_ui'

import App from '../vue/apps/shared_garden/App.vue'
import routerFor from '../vue/apps/shared_garden/router'
import store from '../vue/apps/shared_garden/store'

import i18n from '../vue/app_helpers/i18n'
import { $emitBus, $onBus } from '../vue/tools/EventBus'

import icons from '../../assets/images/icons.svg'

window.sharedMapApp = function (mapId, slug) {
  const app = createApp(App)
    .use(i18n)
    .use(routerFor(slug))
    .use(store)
    .use(RiseUI, {
      useVueI18n: true,
      i18nObjectAttributesPath: 'activerecord.attributes',
      iconsFile: icons,
    })
  app.config.globalProperties.$onBus = $onBus
  app.config.globalProperties.$emitBus = $emitBus
  app.config.globalProperties.$mapId = mapId
  app.mount('#app')
}
